import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

// API's
import { getMappedPosition } from "@Common/api/positions/queries";

// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// MUI
import { Box, Grid } from "@mui/material";

// Images
import empty from "@/assets/images/commons/empty.png";

// Custom components
import PageLayer from "@/Layouts/views/PageLayer";
import BodyLayer from "@/Layouts/components/Layers/BodyLayer";
import CollapsibleLeftPanel from "@/Layouts/components/CollapsibleLeftPanel";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import FinanceDirectorDepartmentalWashoutLayer from "@/Washouts/views/Layers/Finance/Directors/FinanceDirectorDepartmentalWashoutLayer";
import FinanceDirectorProducerWashoutLayer from "@/Washouts/views/Layers/Finance/Directors/FinanceDirectorProducerWashoutLayer";
import WashoutsSideBar from "@/Washouts/layouts/WashoutsSideBar";

const POSITION = "Finance Director";

const RenderLayer = (props) => {
	const { isDepartmental = false } = props;
	if (isDepartmental) {
		return <FinanceDirectorDepartmentalWashoutLayer />;
	}
	return <FinanceDirectorProducerWashoutLayer />;
};

export default function FinanceDirectorWashout(props) {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const location = useSelector((state) => state.location.location);
	const queryClient = useQueryClient();

	const { data, isLoading } = useQuery({
		queryKey: ["getMappedPosition", "financeDirectorWashout", location?.locationId],
		queryFn: async () => getMappedPosition(location?.locationId, "Finance Director"),
		enabled: !!location?.locationId,
		staleTime: Infinity,
	});

	useEffect(() => {
		return () => {
			queryClient.removeQueries({ queryKey: ["getMappedPosition", "financeDirectorWashout", location?.locationId] });
		};
	}, [queryClient, location?.locationId]);

	return (
		<PageLayer title={"Finance Director Washouts"} icon={Icon}>
			{isLoading ? (
				<BodyLayer
					floatingContent={
						<CollapsibleLeftPanel
							loading={true}
							open={false}
							control={<WashoutsSideBar treeDefinition={{ tree: [] }} loading={true} selected={""} />}
						/>
					}
				>
					<Box sx={{ width: 1 }}>
						<Grid container position="relative" spacing={1}>
							<Grid item xs={12}>
								<RoundedBox sx={{ maxHeight: 630, boxShadow: "none !important" }}>
									<EmptyBody
										image={empty}
										title={"Select a Finance Director to view their washout"}
										bodyHeight={"510px"}
										sx={{
											boxShadow: "none !important",
										}}
									/>
								</RoundedBox>
							</Grid>
						</Grid>
					</Box>
				</BodyLayer>
			) : (
				<RenderLayer isDepartmental={data?.isDepartmental} />
			)}
		</PageLayer>
	);
}
